define.alias("shared/components/shared/wizards/carousel/step-two", "media/components/shared/wizards/carousel/step-two");